const getPaginationFromBody = (body) => ({
  currentPage: body?.page_no || 0,
  nextPage:
    body?.page_no && body?.total_pages && body.page_no < body.total_pages
      ? body.page_no + 1
      : 0,
  pageSize: body?.page_size || 0,
  totalEntries: body?.total_entries || 0,
  totalPages: body?.total_pages || 0,
});

export default getPaginationFromBody;
